import React from 'react';

export default class TooltipStatic extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className={`tooltip-static tooltip-style-${this.props.style}`}>
                <div className="tooltip-icon-static">
                    <img src={this.props.icon}/>
                </div>
                <div className='tooltip-style-orange'>
                    <div dangerouslySetInnerHTML={{__html: this.props.text}} className="tooltip-text"></div>
                </div>
            </div>
        )
    }
}